import { render } from "./StockReport.vue?vue&type=template&id=69d64f0c&ts=true"
import script from "./StockReport.vue?vue&type=script&lang=ts"
export * from "./StockReport.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__